<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="'Developers'"
      [class]="extraClass"
      [canGoBack]="!windowService.isDesktopRes"
      [customBack]="'more'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loaded) {
      @if (isDeveloperEnabled) {
        <tidy-card>
          <tidy-row class="vertical-align-center">
            <tidy-text
              [header]="'Developers'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'Use the TIDY API with your application.'" />
          </tidy-row>
          <tidy-card-button (action)="goToSideRail('api-keys')">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/key.svg'"
                class="header-size" />
              <tidy-text
                [body]="'API Keys'" />
            </tidy-row>
          </tidy-card-button>
          <tidy-card-button (action)="goToSideRail('webhooks')">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/url.svg'"
                class="header-size" />
              <tidy-text
                [body]="'Webhooks'" />
            </tidy-row>
          </tidy-card-button>
          <tidy-card-button (action)="goToExternalPage(developerDocsUrl)">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/info.svg'"
                class="header-size" />
              <tidy-text
                [body]="'Documentation'" />
            </tidy-row>
          </tidy-card-button>
          <tidy-card-button (action)="goToSideRail('logs')">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/logs.svg'"
                class="header-size" />
              <tidy-text
                [body]="'Logs'" />
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
        <tidy-card>
          <tidy-row class="vertical-align-center">
            <tidy-text
              [header]="'Need Help?'" />
          </tidy-row>
          <tidy-card-button (action)="sendEmail()">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/send.svg'"
                class="header-size" />
              <tidy-text
                [body]="'Send Us an Email'" />
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
        @if (!windowService.isDesktopRes && cameFromDeveloperSelfBooking) {
          <tidy-card>
            <tidy-row class="vertical-align-center">
              <tidy-text
                [header]="'Check Out Other Features'" />
            </tidy-row>
            <tidy-card-button (action)="goToPage('to-dos')">
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/to-dos.svg'"
                  class="header-size" />
                <tidy-text
                  [body]="'Checklists'" />
              </tidy-row>
            </tidy-card-button>
            <tidy-card-button (action)="goToPage('schedule')">
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/book-job.svg'"
                  class="header-size" />
                <tidy-text
                  [body]="'Book a Job Instantly'" />
              </tidy-row>
            </tidy-card-button>
            <tidy-card-button (action)="goToPage('contacts')">
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/add-pro.svg'"
                  class="header-size" />
                <tidy-text
                  [body]="'Add a Pro'" />
              </tidy-row>
            </tidy-card-button>
          </tidy-card>
        }
      }
      @if (!isDeveloperEnabled) {
        @if (errorMessage) {
          <tidy-error-message
            [text]="errorMessage" />
        }
        <tidy-button
          [text]="'Enable Developer Features'"
          [action]="boundEnableDeveloperFeatures"
          class="primary" />
        <tidy-card>
          <tidy-row class="vertical-align-center extra-bottom-padding">
            <tidy-text
              [header]="'Free Cleaning & Home Service API'" />
          </tidy-row>
          <tidy-row>
            <tidy-image
              [src]="'assets/img/wireframe-1.svg'"
              class="hero-size" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'TIDY makes it easy to book cleaning or maintenance pros via our API, then manage or track those jobs. Use TIDY with your existing pros or we can help you find one with our Find New Pro workflows. The API is for internal use (e.g. property managers) or for end users of your product (e.g. property management software). Most people use it for free!'" />
          </tidy-row>
        </tidy-card>
        <tidy-card>
          <tidy-row class="vertical-align-center extra-bottom-padding">
            <tidy-text
              [header]="'Request Bookings With Any Pro'" />
          </tidy-row>
          <tidy-row>
            <tidy-image
              [src]="'assets/img/wireframe-2.svg'"
              class="hero-size" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'Define your job request and send to your priority list. Your top priority pro will get the first chance to accept, followed by your next priority and so on.'" />
          </tidy-row>
        </tidy-card>
        <tidy-card>
          <tidy-row class="vertical-align-center extra-bottom-padding">
            <tidy-text
              [header]="'Customize the Job with Checklists'" />
          </tidy-row>
          <tidy-row>
            <tidy-image
              [src]="'assets/img/wireframe-3.svg'"
              class="hero-size" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'Use the API to assign checklists to your jobs.'" />
          </tidy-row>
        </tidy-card>
        <tidy-card>
          <tidy-row class="vertical-align-center extra-bottom-padding">
            <tidy-text
              [header]="'Get Job Updates with Webhooks'" />
          </tidy-row>
          <tidy-row>
            <tidy-image
              [src]="'assets/img/wireframe-4.svg'"
              class="hero-size" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'Use webhooks to get alerts of things like jobs being scheduled, accepted, or completed.'" />
          </tidy-row>
        </tidy-card>
        @if (errorMessage) {
          <tidy-error-message
            [text]="errorMessage" />
        }
        <tidy-button
          [text]="'Enable Developer Features'"
          [action]="boundEnableDeveloperFeatures"
          class="primary" />
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
